const keys = new WeakMap<object, string>();

/**
 * A stable React key for an editable row whose data carries no id.
 *
 * Position is not identity, and the product already recorded what happens when
 * it is used as one — see `HeaderPair` in the webhooks form: removing a row
 * hands the row above's input to its neighbour and the cursor jumps. The rows
 * here are API payload objects, so an `id` field cannot be added to them
 * without shipping it to the backend. The identity is the object itself, which
 * lasts exactly as long as the row does: every edit replaces the object, and a
 * replaced row should remount, because changing a selector's type changes the
 * whole body under it.
 */
export function rowKey(row: object): string {
  const existing = keys.get(row);
  if (existing) return existing;
  const key = crypto.randomUUID();
  keys.set(row, key);
  return key;
}
